import { useEffect, useState } from 'react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { IonicSwiper, IonImg } from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Constants } from '../../defines/Constants';
import axios from 'axios';
import 'swiper/swiper-bundle.min.css';
import './Slides.css';

SwiperCore.use([IonicSwiper, Navigation, Autoplay]);
const Slides = () => {
    const [slides, setSlides] = useState([]);
    const slidesApi = Constants.api.slides;
    useEffect(() => {
        const getBlog = async () => {
            try {
                const results = await axios.get(slidesApi);
                if (results.status === 200) {
                    setSlides(results.data.slides_items);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getBlog();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const slidesEl = slides.map((item: any, index: number) =>
        <SwiperSlide key={"index" + index}>
            <IonImg src={Constants.uploads + 'slides/' + item.image} />
        </SwiperSlide>
    )
    return (
        <Swiper dir="rtl" autoplay={{ "delay": 2500, "disableOnInteraction": false }} navigation={true} spaceBetween={10} className="slider-container" allowTouchMove={true}>
            {slidesEl}
        </Swiper>
    );
};
export default Slides;